document.documentElement.classList.add('colorgrid-booting');

/* =========================================================
   Color Grid (Boost)
   AUTO COLOR FILTER MODE
   v2026-09-04-B

   ■ 動作
   1. color-gridテンプレート
      → 常時カラー表示

   2. 通常テンプレート
      → pf_t_kara が存在するとカラー表示
      → pf_t_kara が消えると代表画像表示へ戻る

   例：
   /collections/dearmylove-op
      → 通常の商品代表画像

   /collections/dearmylove-op?pf_t_kara=ブラック
      → ブラックvariant画像

   ■ 方針
   - view=color 不要
   - Boostカラー選択を自動検知
   - カラー解除で通常表示へ復帰
   - No grid.innerHTML
   - variant画像の戻り防止
========================================================= */

console.warn('[colorGrid] LOADED auto-color v2026-09-04-B');


(function waitFlag() {

  // -------------------------------------------------------
  // 0) 状態判定
  // -------------------------------------------------------

  function getUrlParams() {
    return new URLSearchParams(location.search);
  }


  function getSelectedBoostColor() {
    const params = getUrlParams();

    return params.get('pf_t_kara') || '';
  }


  function isColorGridTemplate() {
    return !!document.querySelector(
      '[data-enable-color-grid="true"]'
    );
  }


  function shouldUseColorGrid() {

    // color-gridテンプレートは常時ON
    if (isColorGridTemplate()) {
      return true;
    }

    // 通常テンプレートはカラー絞り込み時だけON
    return !!getSelectedBoostColor();
  }


  /*
   * このJS自体は通常テンプレートでも
   * Boostフィルター変更を監視する必要があるため、
   * pf_t_kara が無くても完全終了しない
   */

  if (window.__colorGridBooted) return;

  window.__colorGridBooted = true;

  console.warn('[colorGrid] boot flag OK');


  // -------------------------------------------------------
  // 1) Selectors / constants
  // -------------------------------------------------------

  const GRID_SELECTOR =
    '.boost-pfs-filter-products';

  const CELL_SELECTORS = [
    ':scope > .Grid__Cell',
    ':scope > .ProductList__Item',
    ':scope > .boost-pfs-filter-product-item'
  ].join(',');

  const LINK_SELECTOR =
    'a[href*="/products/"]';


  const COLOR_KEYWORDS = [
    'color',
    'カラー',
    'カラー名',
    '色',
    '色味',
    'colour',
    'couleur',
    'colore',
    'farbe',
    'col',
    'clr'
  ];


  const __productCache =
    new Map();


  window.__colorGridRunning =
    false;

  window.__colorGridMutating =
    false;

  window.__colorGridMode =
    false;


  /*
   * 通常の商品一覧を保存するためのMap
   *
   * grid要素ごとに
   * 通常状態のDOM cloneを保持
   */
  const __normalGridSnapshots =
    new WeakMap();


  // -------------------------------------------------------
  // 2) Helpers
  // -------------------------------------------------------

  function uniq(a) {
    return Array.from(
      new Set(a)
    );
  }


  function findGrid() {

    return (
      document.querySelector(
        '.boost-pfs-filter-products'
      ) ||

      document.querySelector(
        '#boost-pfs-filter-products'
      ) ||

      document.querySelector(
        '.boost-pfs-filter-product-list'
      ) ||

      document.querySelector(
        '.ProductList'
      )
    );
  }


  function getGridCells(grid) {

    if (!grid) return [];

    return Array.from(
      grid.querySelectorAll(
        CELL_SELECTORS
      )
    );
  }


  function getHandleFromHref(href) {

    const m =
      (href || '')
        .match(
          /\/products\/([^\/\?#]+)/
        );

    return m
      ? m[1]
      : null;
  }


  function getHandleFromCell(cell) {

    const a =
      cell.querySelector(
        LINK_SELECTOR
      );

    if (!a) {
      return null;
    }

    return getHandleFromHref(
      a.getAttribute('href') || ''
    );
  }


  function normalizeShopifyImgUrl(url) {

    if (!url) {
      return '';
    }

    let u =
      String(url).trim();


    if (
      u.startsWith('//')
    ) {
      u =
        'https:' + u;
    }


    if (
      u.startsWith(
        'cdn.shopify.com'
      )
    ) {
      u =
        'https://' + u;
    }


    /*
     * Shopifyのサイズ指定除去
     */
    u =
      u.replace(
        /_((\d+x\d*)|(\d+x)|(\d+)|({width}x))(?=\.(jpg|jpeg|png|webp)(\?|$))/i,
        ''
      );


    return u;
  }


  async function fetchProductJson(
    handle
  ) {

    if (
      __productCache.has(
        handle
      )
    ) {
      return __productCache.get(
        handle
      );
    }


    const p =
      fetch(
        `/products/${handle}.js`,
        {
          credentials:
            'same-origin'
        }
      )
        .then(res => {

          if (!res.ok) {

            throw new Error(
              'fetch failed: ' +
              handle
            );
          }

          return res.json();
        });


    __productCache.set(
      handle,
      p
    );


    return p;
  }


  function getColorOptionIndex(p) {

    if (
      !Array.isArray(
        p.options
      )
    ) {
      return -1;
    }


    const names =
      p.options.map(
        x =>
          String(x)
            .toLowerCase()
      );


    const idx =
      names.findIndex(
        n =>
          COLOR_KEYWORDS.some(
            k =>
              n.includes(k)
          )
      );


    return idx !== -1
      ? idx
      : 0;
  }


  function getOpt(
    v,
    idx
  ) {

    if (
      Array.isArray(
        v.options
      ) &&
      v.options[idx] != null
    ) {
      return v.options[idx];
    }


    const key =
      'option' +
      (idx + 1);


    return v[key] ?? null;
  }


  function normalizeColorName(
    name
  ) {

    return String(
      name || ''
    )
      .trim()
      .replace(
        /[　\s]/g,
        ''
      )
      .replace(
        /系$/,
        ''
      );
  }


  /*
   * Boost側の大分類カラーと
   * 商品variant名を合わせる
   */
  function normalizeFilterMatchColor(
    name
  ) {

    const color =
      normalizeColorName(
        name
      );


    // ----------------
    // ブラック
    // ----------------

    if (
      color.includes(
        'ブラック'
      )
    ) {
      return 'ブラック';
    }

    if (
      color === '黒'
    ) {
      return 'ブラック';
    }


    // ----------------
    // レッド系
    // ----------------

    if (
      color.includes(
        'ボルドー'
      )
    ) {
      return 'レッド';
    }

    if (
      color.includes(
        'ワイン'
      )
    ) {
      return 'レッド';
    }

    if (
      color.includes(
        'バーガンディ'
      )
    ) {
      return 'レッド';
    }


    // ----------------
    // ホワイト系
    // ----------------

    if (
      color.includes(
        'アイボリー'
      )
    ) {
      return 'ホワイト';
    }

    if (
      color.includes(
        'エクリュ'
      )
    ) {
      return 'ホワイト';
    }


    // ----------------
    // パープル系
    // ----------------

    if (
      color.includes(
        'ラベンダー'
      )
    ) {
      return 'パープル';
    }

    if (
      color.includes(
        'モーヴ'
      )
    ) {
      return 'パープル';
    }


    // ----------------
    // ブルー系
    // ----------------

    if (
      color.includes(
        'サックス'
      )
    ) {
      return 'ブルー';
    }

    if (
      color.includes(
        'ネイビー'
      )
    ) {
      return 'ブルー';
    }


    // ----------------
    // グレー系
    // ----------------

    if (
      color.includes(
        'チャコール'
      )
    ) {
      return 'グレー';
    }


    // ----------------
    // ブラウン系
    // ----------------

    if (
      color.includes(
        'モカ'
      )
    ) {
      return 'ブラウン';
    }

    if (
      color.includes(
        'キャメル'
      )
    ) {
      return 'ブラウン';
    }


    // ----------------
    // イエロー系
    // ----------------

    if (
      color.includes(
        'ライム'
      )
    ) {
      return 'イエロー';
    }


    return color;
  }


  function colorMatchesFilter(
    variantColor,
    filterColor
  ) {

    const vc =
      normalizeFilterMatchColor(
        variantColor
      );

    const fc =
      normalizeFilterMatchColor(
        filterColor
      );


    if (
      !vc ||
      !fc
    ) {
      return false;
    }


    return vc === fc;
  }


  function getImgFromVariant(
    v,
    fallback
  ) {

    if (
      v?.featured_image
    ) {

      if (
        typeof
          v.featured_image ===
        'string'
      ) {
        return (
          v.featured_image
        );
      }


      if (
        v.featured_image.src
      ) {
        return (
          v.featured_image.src
        );
      }
    }


    if (
      v?.image
    ) {

      if (
        typeof v.image ===
        'string'
      ) {
        return v.image;
      }


      if (
        v.image.src
      ) {
        return v.image.src;
      }
    }


    return fallback || '';
  }


  // -------------------------------------------------------
  // 3) 通常表示の保存
  // -------------------------------------------------------

  function saveNormalSnapshot(
    grid
  ) {

    if (!grid) return;


    /*
     * すでにカラー展開されている状態は保存しない
     */
    if (
      grid.querySelector(
        '[data-color-expanded="1"]'
      )
    ) {
      return;
    }


    const cells =
      getGridCells(grid);


    if (!cells.length) {
      return;
    }


    /*
     * 現在のBoost結果を保存
     *
     * HTML文字列ではなく
     * cloneNodeで保存
     */
    const snapshot =
      cells.map(
        cell =>
          cell.cloneNode(true)
      );


    __normalGridSnapshots.set(
      grid,
      snapshot
    );


    console.warn(
      '[colorGrid] normal snapshot saved',
      snapshot.length
    );
  }


  // -------------------------------------------------------
  // 4) 代表画像表示へ戻す
  // -------------------------------------------------------

  function restoreNormalGrid(
    reason
  ) {

    const grid =
      findGrid();

    if (!grid) return;


    /*
     * color-gridテンプレートでは
     * 通常表示に戻さない
     */
    if (
      isColorGridTemplate()
    ) {
      return;
    }


    const snapshot =
      __normalGridSnapshots.get(
        grid
      );


    /*
     * Boostがすでに通常表示を
     * 再生成しているなら何もしない
     */
    const expanded =
      grid.querySelectorAll(
        '[data-color-expanded="1"]'
      );


    if (!expanded.length) {

      window.__colorGridMode =
        false;

      markNormalGridReady();

      saveNormalSnapshot(
        grid
      );

      return;
    }


    /*
     * snapshotが無い場合は
     * 展開セルだけ削除すると
     * 商品が消えるので触らない
     *
     * Boostの次回レンダリングを待つ
     */
    if (
      !snapshot ||
      !snapshot.length
    ) {

      console.warn(
        '[colorGrid] restore skipped - no snapshot',
        reason || ''
      );

      return;
    }


    console.warn(
      '[colorGrid] restore normal',
      reason || ''
    );


    window.__colorGridMutating =
      true;


    try {

      const currentCells =
        getGridCells(grid);


      if (!currentCells.length) {
        return;
      }


      const firstCell =
        currentCells[0];


      const frag =
        document.createDocumentFragment();


      snapshot.forEach(
        node => {

          const clone =
            node.cloneNode(true);


          /*
           * ColorGrid属性を完全削除
           */
          clone.removeAttribute(
            'data-color-expanded'
          );

          clone.removeAttribute(
            'data-color-expanded-group'
          );

          clone.removeAttribute(
            'data-product-handle'
          );

          clone.removeAttribute(
            'data-variant-id'
          );


          clone
            .querySelectorAll(
              '[data-color-expanded],' +
              '[data-color-expanded-group],' +
              '[data-product-handle],' +
              '[data-variant-id],' +
              '[data-colorgrid-desired],' +
              '[data-colorgrid-fixed]'
            )
            .forEach(
              el => {

                el.removeAttribute(
                  'data-color-expanded'
                );

                el.removeAttribute(
                  'data-color-expanded-group'
                );

                el.removeAttribute(
                  'data-product-handle'
                );

                el.removeAttribute(
                  'data-variant-id'
                );

                el.removeAttribute(
                  'data-colorgrid-desired'
                );

                el.removeAttribute(
                  'data-colorgrid-fixed'
                );

              }
            );


          frag.appendChild(
            clone
          );
        });


      firstCell.before(
        frag
      );


      currentCells.forEach(
        cell => {

          try {
            cell.remove();
          } catch(e) {}

        }
      );


      window.__colorGridMode =
        false;


      markNormalGridReady();


    } finally {

      setTimeout(
        () => {

          window.__colorGridMutating =
            false;

        },
        0
      );
    }
  }


  // -------------------------------------------------------
  // 5) Protect image
  // -------------------------------------------------------

  function setImgEverywhere(
    img,
    url
  ) {

    url =
      normalizeShopifyImgUrl(
        url
      );


    if (!url) {
      return;
    }


    img.setAttribute(
      'src',
      url
    );


    img.removeAttribute(
      'srcset'
    );


    img.removeAttribute(
      'sizes'
    );


    img.removeAttribute(
      'data-src'
    );


    img.removeAttribute(
      'data-srcset'
    );


    img.loading =
      'eager';


    img.decoding =
      'async';


    const pic =
      img.closest(
        'picture'
      );


    if (pic) {

      pic
        .querySelectorAll(
          'source'
        )
        .forEach(
          s =>
            s.remove()
        );
    }
  }


  function protectImg(
    img,
    desiredUrl
  ) {

    desiredUrl =
      normalizeShopifyImgUrl(
        desiredUrl
      );


    if (
      !img ||
      !desiredUrl
    ) {
      return;
    }


    img.setAttribute(
      'data-colorgrid-desired',
      desiredUrl
    );


    img.src =
      desiredUrl;


    img.removeAttribute(
      'data-src'
    );


    img.removeAttribute(
      'data-srcset'
    );


    img.removeAttribute(
      'sizes'
    );


    img.setAttribute(
      'data-colorgrid-fixed',
      '1'
    );


    setImgEverywhere(
      img,
      desiredUrl
    );


    if (
      img.__colorGridProtected
    ) {
      return;
    }


    img.__colorGridProtected =
      true;


    const obs =
      new MutationObserver(
        () => {

          /*
           * カラー表示解除後は
           * protectしない
           */
          if (
            !shouldUseColorGrid()
          ) {
            return;
          }


          const want =
            img.getAttribute(
              'data-colorgrid-desired'
            ) || '';


          if (!want) {
            return;
          }


          const cur =
            (
              img.getAttribute(
                'src'
              ) || ''
            )
              .split('?')[0];


          const w0 =
            want.split('?')[0];


          if (
            cur &&
            w0 &&
            cur !== w0
          ) {

            setImgEverywhere(
              img,
              want
            );
          }
        }
      );


    obs.observe(
      img,
      {
        attributes: true,
        attributeFilter: [
          'src',
          'srcset',
          'data-src',
          'data-srcset',
          'sizes'
        ]
      }
    );


    img.__colorGridObs =
      obs;
  }


  // -------------------------------------------------------
  // 6) Patch Cell
  // -------------------------------------------------------

  function patchCell(
    cell,
    variantId,
    imgUrl
  ) {

    imgUrl =
      normalizeShopifyImgUrl(
        imgUrl
      );


    if (
      !imgUrl ||
      !variantId
    ) {
      return;
    }


    cell
      .querySelectorAll(
        LINK_SELECTOR
      )
      .forEach(
        a => {

          const base =
            (
              a.getAttribute(
                'href'
              ) || ''
            )
              .split('?')[0];


          a.setAttribute(
            'href',
            base +
            '?variant=' +
            variantId
          );

        }
      );


    const pickImg =
      () =>

        cell.querySelector(
          'img.ProductItem__Image:not(.ProductItem__Image--alternate)'
        ) ||

        cell.querySelector(
          'a.ProductItem__ImageWrapper img'
        ) ||

        cell.querySelector(
          '.ProductItem__ImageWrapper img'
        ) ||

        cell.querySelector(
          'img'
        );


    const img =
      pickImg();


    if (!img) {
      return;
    }


    protectImg(
      img,
      imgUrl
    );


    const loader =
      cell.querySelector(
        '.Image__Loader,' +
        '.image__loader,' +
        '.product__loader'
      );


    if (loader) {
      loader.remove();
    }


    /*
     * Boost / Themeが
     * imgを作り直した場合
     */
    if (
      !cell.__colorGridCellObs
    ) {

      const obs =
        new MutationObserver(
          () => {

            if (
              !shouldUseColorGrid()
            ) {
              return;
            }


            const newImg =
              pickImg();


            if (!newImg) {
              return;
            }


            const desired =
              newImg.getAttribute(
                'data-colorgrid-desired'
              ) ||
              imgUrl;


            protectImg(
              newImg,
              desired
            );

          }
        );


      obs.observe(
        cell,
        {
          childList: true,
          subtree: true
        }
      );


      cell.__colorGridCellObs =
        obs;
    }
  }


  // -------------------------------------------------------
  // 7) Rebuild Color Grid
  // -------------------------------------------------------

  async function rebuild(
    reason
  ) {

    /*
     * カラー表示条件が無ければ
     * 通常表示へ戻す
     */
    if (
      !shouldUseColorGrid()
    ) {

      restoreNormalGrid(
        reason ||
        'color-off'
      );

      return;
    }


    if (
      window.__colorGridRunning
    ) {
      return;
    }


    window.__colorGridRunning =
      true;


    const grid =
      findGrid();


    if (!grid) {

      window.__colorGridRunning =
        false;

      return;
    }


    try {

      const allCells =
        getGridCells(
          grid
        );


      if (!allCells.length) {
        return;
      }


      /*
       * カラー展開前に
       * 通常Boost結果を保存
       */
      const hasExpanded =
        allCells.some(
          c =>
            c.hasAttribute(
              'data-color-expanded'
            )
        );


      if (!hasExpanded) {

        saveNormalSnapshot(
          grid
        );
      }


      const baseCells =
        allCells.filter(
          c =>
            !c.hasAttribute(
              'data-color-expanded'
            )
        );


      console.warn(
        '[colorGrid] rebuild',
        reason || '',
        'color=',
        getSelectedBoostColor(),
        'cells=',
        allCells.length,
        'base=',
        baseCells.length
      );


      // ---------------------------------------------------
      // すでにカラー展開済み
      // ---------------------------------------------------

      if (
        !baseCells.length
      ) {

        const expanded =
          Array.from(
            grid.querySelectorAll(
              '[data-color-expanded="1"]'
            )
          );


        if (!expanded.length) {
          return;
        }


        const handles =
          uniq(
            expanded
              .map(
                c =>
                  c.getAttribute(
                    'data-product-handle'
                  )
              )
              .filter(Boolean)
          );


        if (!handles.length) {
          return;
        }


        const settled =
          await Promise.allSettled(
            handles.map(
              fetchProductJson
            )
          );


        const products =
          settled
            .filter(
              r =>
                r.status ===
                'fulfilled'
            )
            .map(
              r =>
                r.value
            );


        if (!products.length) {
          return;
        }


        /*
         * URLカラーが変わった場合、
         * 現在展開済みDOMでは別カラーへ
         * 切り替えられないので、
         * 通常snapshotへ一度戻す
         */
        const selectedColor =
          normalizeFilterMatchColor(
            getSelectedBoostColor()
          );


        const currentGridColor =
          grid.getAttribute(
            'data-colorgrid-current-filter'
          ) || '';


        if (
          selectedColor &&
          currentGridColor &&
          selectedColor !==
            currentGridColor
        ) {

          console.warn(
            '[colorGrid] filter changed',
            currentGridColor,
            '->',
            selectedColor
          );


          restoreNormalGrid(
            'filter-change'
          );


          setTimeout(
            () =>
              rebuild(
                'filter-change-rebuild'
              ),
            30
          );


          return;
        }


        for (
          const cell
          of expanded
        ) {

          const h =
            cell.getAttribute(
              'data-product-handle'
            );


          const vid =
            Number(
              cell.getAttribute(
                'data-variant-id'
              )
            );


          if (
            !h ||
            !vid
          ) {
            continue;
          }


          const p =
            products.find(
              x =>
                x.handle === h
            );


          if (!p) {
            continue;
          }


          const v =
            (p.variants || [])
              .find(
                x =>
                  x.id === vid
              );


          if (!v) {
            continue;
          }


          patchCell(
            cell,
            vid,
            getImgFromVariant(
              v,
              p.featured_image
            )
          );
        }


        markColorGridReady();

        return;
      }


      // ---------------------------------------------------
      // 商品JSON取得
      // ---------------------------------------------------

      const handles =
        baseCells
          .map(
            getHandleFromCell
          )
          .filter(Boolean);


      const uniqueHandles =
        uniq(
          handles
        );


      if (
        !uniqueHandles.length
      ) {
        return;
      }


      const settled =
        await Promise.allSettled(
          uniqueHandles.map(
            fetchProductJson
          )
        );


      const products =
        settled
          .filter(
            r =>
              r.status ===
              'fulfilled'
          )
          .map(
            r =>
              r.value
          );


      if (!products.length) {
        return;
      }


      // ---------------------------------------------------
      // handleごとにまとめる
      // ---------------------------------------------------

      const byHandle =
        new Map();


      for (
        const c
        of baseCells
      ) {

        const h =
          getHandleFromCell(
            c
          );


        if (!h) {
          continue;
        }


        if (
          !byHandle.has(h)
        ) {

          byHandle.set(
            h,
            []
          );
        }


        byHandle
          .get(h)
          .push(c);
      }


      window.__colorGridMutating =
        true;


      try {

        for (
          const [
            handle,
            cellsOfHandle
          ]
          of byHandle.entries()
        ) {

          const p =
            products.find(
              x =>
                x.handle === handle
            );


          if (!p) {
            continue;
          }


          const colorIdx =
            getColorOptionIndex(
              p
            );


          if (
            colorIdx === -1
          ) {
            continue;
          }


          // -------------------------------------------------
          // 在庫ありカラー
          // -------------------------------------------------

          let colors =
            uniq(
              (p.variants || [])
                .filter(
                  v =>
                    v.available
                )
                .map(
                  v =>
                    getOpt(
                      v,
                      colorIdx
                    )
                )
                .filter(Boolean)
            );


          // -------------------------------------------------
          // 通常テンプレート：
          // Boostカラーだけ表示
          //
          // color-gridテンプレート：
          // pf_t_karaがあればそのカラー、
          // 無ければ全色
          // -------------------------------------------------

          const selectedBoostColor =
            getSelectedBoostColor();


          if (
            selectedBoostColor
          ) {

            colors =
              colors.filter(
                color =>
                  colorMatchesFilter(
                    color,
                    selectedBoostColor
                  )
              );
          }


          /*
           * 最大5色
           */
          colors =
            colors.slice(
              0,
              5
            );


          if (
            !colors.length
          ) {

            cellsOfHandle
              .forEach(
                c => {

                  try {
                    c.remove();
                  } catch(e) {}

                }
              );

            continue;
          }


          const templateCell =

            cellsOfHandle.find(
              c =>
                c.querySelectorAll(
                  '.ProductItem'
                ).length <= 1
            ) ||

            cellsOfHandle[0];


          if (
            !templateCell ||
            !templateCell.isConnected
          ) {
            continue;
          }


          const groupId =
            handle +
            '-' +
            Date.now();


          const frag =
            document.createDocumentFragment();


          for (
            const colorName
            of colors
          ) {

            /*
             * そのカラーで在庫ありの
             * 最初のvariantを使用
             */
            const v =
              (p.variants || [])
                .find(
                  x => {

                    return (
                      x.available &&
                      normalizeColorName(
                        getOpt(
                          x,
                          colorIdx
                        )
                      ) ===
                      normalizeColorName(
                        colorName
                      )
                    );

                  }
                );


            if (!v) {
              continue;
            }


            const clone =
              templateCell.cloneNode(
                true
              );


            // -----------------------------------------------
            // ProductItem複数防止
            // -----------------------------------------------

            const items =
              Array.from(
                clone.querySelectorAll(
                  '.ProductItem'
                )
              );


            if (
              items.length > 1
            ) {

              for (
                let k = 1;
                k < items.length;
                k++
              ) {

                items[k].remove();
              }
            }


            // -----------------------------------------------
            // 古い属性削除
            // -----------------------------------------------

            clone
              .querySelectorAll(
                '[data-color-expanded],' +
                '[data-color-expanded-group],' +
                '[data-product-handle],' +
                '[data-variant-id]'
              )
              .forEach(
                el => {

                  el.removeAttribute(
                    'data-color-expanded'
                  );

                  el.removeAttribute(
                    'data-color-expanded-group'
                  );

                  el.removeAttribute(
                    'data-product-handle'
                  );

                  el.removeAttribute(
                    'data-variant-id'
                  );

                }
              );


            // -----------------------------------------------
            // clone自身に設定
            // -----------------------------------------------

            clone.setAttribute(
              'data-color-expanded',
              '1'
            );


            clone.setAttribute(
              'data-color-expanded-group',
              groupId
            );


            clone.setAttribute(
              'data-product-handle',
              handle
            );


            clone.setAttribute(
              'data-variant-id',
              String(v.id)
            );


            patchCell(
              clone,
              v.id,
              getImgFromVariant(
                v,
                p.featured_image
              )
            );


            frag.appendChild(
              clone
            );
          }


          if (
            frag.childNodes.length
          ) {

            templateCell.replaceWith(
              frag
            );


            /*
             * 同商品重複Base削除
             */
            for (
              let i = 1;
              i <
              cellsOfHandle.length;
              i++
            ) {

              try {

                cellsOfHandle[i]
                  .remove();

              } catch(e) {}
            }
          }
        }


        const selectedColor =
          normalizeFilterMatchColor(
            getSelectedBoostColor()
          );


        if (
          selectedColor
        ) {

          grid.setAttribute(
            'data-colorgrid-current-filter',
            selectedColor
          );

        } else {

          grid.removeAttribute(
            'data-colorgrid-current-filter'
          );
        }


        window.__colorGridMode =
          true;


        markColorGridReady();


      } finally {

        setTimeout(
          () => {

            window.__colorGridMutating =
              false;

          },
          0
        );
      }


      // ---------------------------------------------------
      // Lazy / Boost画像戻り対策
      // ---------------------------------------------------

      [
        200,
        700,
        1400,
        2200
      ]
        .forEach(
          ms => {

            setTimeout(
              () => {

                if (
                  !shouldUseColorGrid()
                ) {
                  return;
                }


                try {

                  repatchExpandedCells(
                    products
                  );

                } catch(e) {}

              },
              ms
            );

          }
        );


      setTimeout(
        () => {

          if (
            shouldUseColorGrid()
          ) {

            rebuild(
              'repatch'
            );
          }

        },
        250
      );


      setTimeout(
        () => {

          if (
            shouldUseColorGrid()
          ) {

            markColorGridReady();
          }

        },
        350
      );


    } catch(e) {

      console.warn(
        '[colorGrid] rebuild error',
        e
      );

    } finally {

      window.__colorGridRunning =
        false;
    }
  }


  // -------------------------------------------------------
  // 8) Ready classes
  // -------------------------------------------------------

  function markColorGridReady() {

    const g =
      findGrid();


    if (g) {

      g.classList.add(
        'is-colorgrid-ready'
      );


      g.classList.remove(
        'is-normalgrid-ready'
      );
    }


    document.documentElement
      .classList.remove(
        'colorgrid-booting'
      );


    document.documentElement
      .classList.add(
        'colorgrid-ready'
      );


    document.documentElement
      .classList.remove(
        'normalgrid-ready'
      );
  }


  function markNormalGridReady() {

    const g =
      findGrid();


    if (g) {

      g.classList.remove(
        'is-colorgrid-ready'
      );


      g.classList.add(
        'is-normalgrid-ready'
      );


      g.removeAttribute(
        'data-colorgrid-current-filter'
      );
    }


    document.documentElement
      .classList.remove(
        'colorgrid-booting'
      );


    document.documentElement
      .classList.remove(
        'colorgrid-ready'
      );


    document.documentElement
      .classList.add(
        'normalgrid-ready'
      );
  }


  window.__colorGridManualRebuild =
    rebuild;


  // -------------------------------------------------------
  // 9) Expanded Repatch
  // -------------------------------------------------------

  function repatchExpandedCells(
    products
  ) {

    if (
      !shouldUseColorGrid()
    ) {
      return;
    }


    const grid =
      findGrid();


    if (!grid) {
      return;
    }


    const expanded =
      Array.from(
        grid.querySelectorAll(
          '[data-color-expanded="1"]'
        )
      );


    console.warn(
      '[colorGrid] repatchExpandedCells',
      expanded.length
    );


    for (
      const cell
      of expanded
    ) {

      const handle =
        cell.getAttribute(
          'data-product-handle'
        );


      const vid =
        Number(
          cell.getAttribute(
            'data-variant-id'
          )
        );


      if (
        !handle ||
        !vid
      ) {
        continue;
      }


      const p =
        products.find(
          x =>
            x.handle === handle
        );


      if (!p) {
        continue;
      }


      const v =
        (p.variants || [])
          .find(
            x =>
              x.id === vid
          );


      if (!v) {
        continue;
      }


      patchCell(
        cell,
        vid,
        getImgFromVariant(
          v,
          p.featured_image
        )
      );
    }
  }


  // -------------------------------------------------------
  // 10) Final Safety
  // -------------------------------------------------------

  function forceRepatchAfterRender() {

    if (
      !shouldUseColorGrid()
    ) {
      return;
    }


    const grid =
      findGrid();


    if (!grid) {
      return;
    }


    const imgs =
      grid.querySelectorAll(
        'img'
      );


    imgs.forEach(
      img => {

        const desired =
          img.getAttribute(
            'data-colorgrid-desired'
          );


        if (!desired) {
          return;
        }


        const cur =
          normalizeShopifyImgUrl(
            img.getAttribute(
              'src'
            ) ||
            img.src
          );


        const want =
          normalizeShopifyImgUrl(
            desired
          );


        if (
          cur.split('?')[0] !==
          want.split('?')[0]
        ) {

          console.warn(
            '[colorGrid] force repatch',
            want
          );


          setImgEverywhere(
            img,
            want
          );
        }

      }
    );
  }


  // -------------------------------------------------------
  // 11) URL変更検知
  // BoostはpushState / replaceStateを使う場合がある
  // -------------------------------------------------------

  function hookHistoryChange() {

    if (
      window.__colorGridHistoryHooked
    ) {
      return;
    }


    window.__colorGridHistoryHooked =
      true;


    let lastUrl =
      location.href;


    function checkUrlChange(
      reason
    ) {

      const now =
        location.href;


      if (
        now === lastUrl
      ) {
        return;
      }


      const before =
        lastUrl;


      lastUrl =
        now;


      console.warn(
        '[colorGrid] URL changed',
        reason || '',
        before,
        '->',
        now
      );


      setTimeout(
        () => {

          handleModeChange(
            'url'
          );

        },
        80
      );
    }


    const rawPushState =
      history.pushState;


    history.pushState =
      function() {

        const result =
          rawPushState.apply(
            this,
            arguments
          );


        checkUrlChange(
          'pushState'
        );


        return result;
      };


    const rawReplaceState =
      history.replaceState;


    history.replaceState =
      function() {

        const result =
          rawReplaceState.apply(
            this,
            arguments
          );


        checkUrlChange(
          'replaceState'
        );


        return result;
      };


    window.addEventListener(
      'popstate',
      () => {

        checkUrlChange(
          'popstate'
        );
      }
    );


    /*
     * 念のためURL監視
     */
    setInterval(
      () => {

        checkUrlChange(
          'poll'
        );

      },
      500
    );
  }


  // -------------------------------------------------------
  // 12) モード切替
  // -------------------------------------------------------

  function handleModeChange(
    reason
  ) {

    const wantsColor =
      shouldUseColorGrid();


    console.warn(
      '[colorGrid] mode check',
      reason || '',
      {
        wantsColor,
        selectedColor:
          getSelectedBoostColor(),
        template:
          isColorGridTemplate()
      }
    );


    if (
      wantsColor
    ) {

      document.documentElement
        .classList.add(
          'colorgrid-booting'
        );


      /*
       * BoostのDOM更新完了を少し待つ
       */
      setTimeout(
        () =>
          rebuild(
            reason ||
            'color-on'
          ),
        100
      );


      setTimeout(
        () =>
          rebuild(
            (reason || '') +
            '-retry'
          ),
        400
      );


      setTimeout(
        forceRepatchAfterRender,
        800
      );


    } else {

      /*
       * Boost側がフィルター解除後に
       * 通常DOMを再生成する可能性が高いので
       * 少し待ってから判定
       */

      setTimeout(
        () => {

          restoreNormalGrid(
            reason ||
            'color-off'
          );

        },
        120
      );


      setTimeout(
        () => {

          const grid =
            findGrid();


          if (!grid) {
            return;
          }


          /*
           * Boostが通常DOMを再生成していたら
           * それを新しいsnapshotとして保存
           */
          if (
            !grid.querySelector(
              '[data-color-expanded="1"]'
            )
          ) {

            saveNormalSnapshot(
              grid
            );


            markNormalGridReady();
          }

        },
        450
      );
    }
  }


  // -------------------------------------------------------
  // 13) Boost DOM監視
  // -------------------------------------------------------

  function hookBoostAutoRender() {

    if (
      window.__colorGridAutoHooked
    ) {
      return;
    }


    window.__colorGridAutoHooked =
      true;


    const root =

      document.querySelector(
        '.CollectionInner__Products'
      ) ||

      document.querySelector(
        '.ProductListWrapper'
      ) ||

      document.querySelector(
        '.boost-pfs-filter-wrapper'
      ) ||

      document.body;


    if (!root) {
      return;
    }


    let timer =
      null;


    const schedule =
      why => {

        clearTimeout(
          timer
        );


        timer =
          setTimeout(
            () => {

              if (
                window.__colorGridMutating
              ) {
                return;
              }


              const grid =
                findGrid();


              if (!grid) {
                return;
              }


              if (
                shouldUseColorGrid()
              ) {

                rebuild(
                  why ||
                  'dom'
                );

              } else {

                /*
                 * 通常表示なら
                 * Boostが生成したDOMを保存
                 */
                if (
                  !grid.querySelector(
                    '[data-color-expanded="1"]'
                  )
                ) {

                  saveNormalSnapshot(
                    grid
                  );


                  markNormalGridReady();

                } else {

                  restoreNormalGrid(
                    why ||
                    'dom-color-off'
                  );
                }
              }

            },
            180
          );
      };


    const obs =
      new MutationObserver(
        () => {

          if (
            window.__colorGridMutating
          ) {
            return;
          }


          schedule(
            'dom'
          );
        }
      );


    obs.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );


    schedule(
      'init'
    );


    setTimeout(
      () =>
        schedule(
          'init2'
        ),
      500
    );


    setTimeout(
      () =>
        schedule(
          'init3'
        ),
      1200
    );
  }


  // -------------------------------------------------------
  // 14) CSS
  // -------------------------------------------------------

  (function injectCSSOnce() {

    if (
      document.getElementById(
        'color-grid-css'
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'color-grid-css';


    style.textContent =
      '.ProductItem__ImageWrapper .AspectRatio{' +
      'aspect-ratio:5/6;' +
      'padding-bottom:0!important;' +
      '}\n';


    document.head.appendChild(
      style
    );

  })();


  // -------------------------------------------------------
  // 15) Boot
  // -------------------------------------------------------

  (function boot() {

    let booted =
      false;


    function tryBoot() {

      const grid =
        document.querySelector(
          GRID_SELECTOR
        ) ||
        findGrid();


      if (!grid) {

        setTimeout(
          tryBoot,
          120
        );

        return;
      }


      if (booted) {
        return;
      }


      booted =
        true;


      console.warn(
        '[colorGrid] tryBoot OK'
      );


      hookHistoryChange();

      hookBoostAutoRender();


      /*
       * 初回が通常表示なら
       * まずBoostの商品セルを保存
       */
      if (
        !shouldUseColorGrid()
      ) {

        saveNormalSnapshot(
          grid
        );


        markNormalGridReady();

      } else {

        setTimeout(
          () =>
            rebuild(
              'boot'
            ),
          0
        );


        setTimeout(
          () =>
            rebuild(
              'boot2'
            ),
          400
        );


        setTimeout(
          forceRepatchAfterRender,
          600
        );


        setTimeout(
          forceRepatchAfterRender,
          1200
        );


        setTimeout(
          forceRepatchAfterRender,
          2000
        );
      }
    }


    if (
      document.readyState ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        tryBoot
      );

    } else {

      tryBoot();
    }

  })();

})();